const state = {
    userInfo: null, // 用户信息
    activeMenu: null,
    userCouponInfo: null,
  };
  
  export default state;
  